<template>
    <div class="navigation">
        <div class="logo_box">
            <img :src="`${$STATIC_URL}/admin/img/logo_w.png`" alt="" class="logo">
            <p class="txt">Super Admin</p>
        </div>
        <ul class="nav accordion">
            <li :class="{ show: isActive('/admin/home') }">
                <div class="acc_tit">
                    <span class="icon"><img :src="`${$STATIC_URL}/admin/img/ico_nav1.png`" alt=""></span>
                    <span class="title">대시보드</span>
                    <span class="arrow"></span>
                </div>
                <ul class="sub_nav" :style="{ display: isActive('/admin/home') ? 'block' : 'none' }">
                    <li>
                        <router-link to="/admin/home" class="link" :class="{ on: isActive('/admin/home') }">기본 통계</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ show: isActive('/admin/user_list') || isActive('/admin/user_quotes') }">
                <div class="acc_tit">
                    <span class="icon"><img :src="`${$STATIC_URL}/admin/img/ico_nav2.png`" alt=""></span>
                    <span class="title">회원정보</span>
                    <span class="arrow"></span>
                </div>
                <ul class="sub_nav" :style="{ display: isActive('/admin/user_list') || isActive('/admin/user_quotes') ? 'block' : 'none' }">
                    <li>
                        <router-link to="/admin/user_list" class="link" :class="{ on: isActive('/admin/user_list') }">회원 목록</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/user_quotes" class="link" :class="{ on: isActive('/admin/user_quotes') }">회원 현황</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ show: isActive('/admin/payment_quote') || isActive('/admin/payment_list') }">
                <div class="acc_tit">
                    <span class="icon"><img :src="`${$STATIC_URL}/admin/img/ico_nav3.png`" alt=""></span>
                    <span class="title">매출관리</span>
                    <span class="arrow"></span>
                </div>
                <ul class="sub_nav" :style="{ display: isActive('/admin/payment_quote') || isActive('/admin/payment_list') ? 'block' : 'none' }">
                    <li>
                        <router-link to="/admin/payment_quote" class="link" :class="{ on: isActive('/admin/payment_quote') }">매출현황</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/payment_list" class="link" :class="{ on: isActive('/admin/payment_list') }">결제내역</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ show: isActive('/admin/traffic_quote') || isActive('/admin/connect_quote') }">
                <div class="acc_tit">
                    <span class="icon"><img :src="`${$STATIC_URL}/admin/img/ico_nav4.png`" alt=""></span>
                    <span class="title">접속통계</span>
                        <span class="arrow"></span>
                </div>
                <ul class="sub_nav" :style="{ display: isActive('/admin/traffic_quote') || isActive('/admin/connect_quote') ? 'block' : 'none' }">
                    <li>
                        <router-link to="/admin/traffic_quote" class="link" :class="{ on: isActive('/admin/traffic_quote') }">트래픽 분석</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/connect_quote" class="link" :class="{ on: isActive('/admin/connect_quote') }">접속환경 분석</router-link>
                    </li>
                </ul>
            </li>
            <li class="line"></li>
            <li :class="{ show: isActive('/admin/number') }">
                <div class="acc_tit">
                    <span class="icon"><img :src="`${$STATIC_URL}/admin/img/ico_nav5.png`" alt=""></span>
                    <span class="title">설정</span>
                    <span class="arrow"></span>
                </div>
                <ul class="sub_nav" :style="{ display: isActive('/admin/number') || isActive('/admin/draw_list') ? 'block' : 'none' }">
                    <li>
                        <router-link to="/admin/number" class="link" :class="{ on: isActive('/admin/number') }">번호입력</router-link>
                    </li>
                    <li>
                        <router-link to="/admin/draw_list" class="link" :class="{ on: isActive('/admin/draw_list') }">당첨번호</router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="btn_box">
            <button type="button" class="btn full" @click="requestLogout">로그아웃</button>
        </div>
        <button type="button" class="nav_btn"></button>
    </div>
</template>
<script setup>
import { adminLogout } from '@/api';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
function isActive(path) {
    return route.path === path;
}
async function requestLogout() {
    await adminLogout();
    router.push('/admin_login/login');
}
</script>
<style></style>